import { useIsTeacher } from '@reducers/user/hooks';
import { useQueryClient } from 'react-query';
import React from 'react';
import {
  updateCachedTestletSession,
  updateCachedTestletSessionActivity,
} from '../utils/queryHelper';
import { TestletSessionActivityActiveType } from '../types';
import LearnosityExamsEventEmitter, {
  MessageFnType,
  TestletSessionActivityNotificationPayload,
  LearnosityExamsEvents,
} from '../utils/LearnosityExamsEventEmitter';

const useTestletSessionActivityNotification = () => {
  const isTeacher = useIsTeacher();
  const queryClient = useQueryClient();

  React.useEffect(() => {
    if (!isTeacher) {
      return;
    }

    const testletSessionActivitySubscriber: MessageFnType = (payload) => {
      const testletSessionActivityPayload =
        payload as TestletSessionActivityNotificationPayload;

      updateCachedTestletSessionActivity(
        queryClient,
        {
          id: testletSessionActivityPayload.testlet_session_id,
          ...testletSessionActivityPayload,
        },
        testletSessionActivityPayload.testlet_session_id,
      );

      updateCachedTestletSession(
        queryClient,
        {
          id: testletSessionActivityPayload.testlet_session_id,
          active:
            testletSessionActivityPayload.event_type as TestletSessionActivityActiveType,
        },
        testletSessionActivityPayload.testlet_id,
      );
    };
    LearnosityExamsEventEmitter.on(
      LearnosityExamsEvents.TESTLET_FOCUSED,
      testletSessionActivitySubscriber,
    );
    LearnosityExamsEventEmitter.on(
      LearnosityExamsEvents.TESTLET_UNFOCUSED,
      testletSessionActivitySubscriber,
    );
    LearnosityExamsEventEmitter.on(
      LearnosityExamsEvents.TESTLET_INACTIVE,
      testletSessionActivitySubscriber,
    );
    return () => {
      LearnosityExamsEventEmitter.off(
        LearnosityExamsEvents.TESTLET_FOCUSED,
        testletSessionActivitySubscriber,
      );
      LearnosityExamsEventEmitter.off(
        LearnosityExamsEvents.TESTLET_UNFOCUSED,
        testletSessionActivitySubscriber,
      );
      LearnosityExamsEventEmitter.off(
        LearnosityExamsEvents.TESTLET_INACTIVE,
        testletSessionActivitySubscriber,
      );
    };
  }, [isTeacher, queryClient]);
};

export default useTestletSessionActivityNotification;
